module.exports = __webpack_public_path__ + "img/no-4.84b85c10.svg";